module.exports = __webpack_public_path__ + "static/img/right-home-row-4.80f024e1.webp";